/**
 * Template: Search
 * ------------------------------------------------------------------------------
 * Highly coupled scripts to power the search page functionality
 *
 * @namespace search
 */
import QuickView from '../components/quick-view';
import Alpine from "alpinejs";

window.Alpine = Alpine;

Alpine.start();

Frame.EventBus.listen('Boost:ready', () => {
  QuickView().init();
});
